import { getPayJury } from '@/api/jury';
import { UserInfo } from '@/api/model/userModel';
import { getInfo } from '@/api/user';
// import APP_CONFIG, { LOCAL_DATA } from '@/APP_CONFIG'
import Toast from '@/components/Toast';
import { handleStatic } from '@/utils';
import { removeOpenId, removeToken, setOpenId, setToken } from '@/utils/auth';
import { defineStore } from 'pinia';
import { UserState } from './typings/user';

export const useUserStore = defineStore({
  id: 'user',
  state: (): UserState => ({
    token: '',
    user: null,
    openid: '',
    payJurys: [],
  }),
  getters: {
    isLogin(state): boolean {
      return state.token != '';
    },
    hasOpenId(state): boolean {
      return state.openid != '';
    },
    hasUserInfo(state): boolean {
      return state.user != null;
    },
    userId(state): number {
      return state.user?.userId as number;
      // if (APP_CONFIG.ENV == 'development') {
      //   return APP_DATA.userId
      // } else {
      //   return state.user?.userId as number
      // }
    },
    face(state): string {
      if (state.user && state.user.photoImageUrl && state.user.photoImageUrl.length) {
        const photoImageUrl = state.user.photoImageUrl[0];
        return handleStatic(photoImageUrl);
      }
      return '';
    },
  },
  actions: {
    async getUserInfo(): Promise<UserInfo | void> {
      Toast({
        type: 'loading',
        title: '正在获取用户信息',
      });
      return new Promise(async (resolve, reject) => {
        await this.getPayInfo();
        return getInfo()
          .then((res) => {
            this.$patch({ user: res.data });
            Toast.close!();
            resolve(res.data);
          })
          .catch((e) => {
            removeToken();
            reject(e);
          });
      });
    },
    getPayInfo() {
      return new Promise((resolve) => {
        getPayJury().then((res) => {
          this.payJurys = res.data;
          resolve(res.data);
        });
      });
    },
    setUserOpenId(openid: string) {
      this.openid = openid;
      setOpenId(openid);
    },
    setUserToken(token: string) {
      this.token = token;
      setToken(token);
    },
    removeUserOpenId() {
      this.openid = '';
      removeOpenId();
    },
    removeUserToken() {
      this.token = '';
      removeToken();
    },
  },
});
